export default __webpack_public_path__ + "static/media/comment.077a1072.svg";